import { Grid, Typography, useTheme } from "@mui/material/index";
import { useTranslation } from "react-i18next";
import { FormDateTimePicker, FormTextField } from "../../common/form-fields-wrappers";
import { IExpiredActionInsertionForm } from "../../models/models";

const ReturnDetails = () => {

    const {t} = useTranslation(['expiredManagement']);
    const theme = useTheme();
    
    return (
        <Grid container>
            <Grid item xs={12}>
                <Typography variant={'h5'} fontWeight={"bold"} color={"primary"}>{t('action.label.returnInfo')}</Typography>
            </Grid>
            <Grid item container xs={12} spacing={theme.spacing(2)}>
                <Grid item xs={12} sm={3}>
                    <FormTextField<IExpiredActionInsertionForm> 
                        name="returnDetails.location"
                        label={t('expiredDetail.form.effectiveCheckOutLocation')}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <FormDateTimePicker<IExpiredActionInsertionForm> 
                        name="returnDetails.date"
                        label={t('expiredDetail.form.effectiveCheckOutDate')}
                        disabled
                    />
                </Grid>
            </Grid>

        </Grid>

    )
}

export default ReturnDetails;